import { render, staticRenderFns } from "./Featured.vue?vue&type=template&id=ea6cc9ea&scoped=true"
import script from "./Featured.vue?vue&type=script&lang=js"
export * from "./Featured.vue?vue&type=script&lang=js"
import style0 from "./Featured.vue?vue&type=style&index=0&id=ea6cc9ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6cc9ea",
  null
  
)

export default component.exports